<template>
  <v-card class="mx-auto">
    <v-card-title class="white--text">
      {{ $t("UserData.PROFILE") }}
    </v-card-title>
    <v-card-text class="relative-position">
      <div class="clear-fix"></div>
      <v-row>
        <v-col class="text-center" cols="12" order="1" order-md="0">
          <v-avatar class="mx-auto" color="primary" size="128">
            <img
                :src="profilePicture || '/user_avatar.png'"
                alt="User Profile Image"
            />
          </v-avatar>
        </v-col>
        <v-col cols="12" order="2" order-md="1">
          <v-expansion-panels v-model="panel" hover multiple>
            <v-expansion-panel>
              <v-expansion-panel-header
                  class="white--text"
                  color="primary expansion-header"
              >
                {{ $t("UserData.PERSONAL_DATA") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="mt-2" no-gutters>
                  <v-col cols="12" lg="6" md="12" sm="12">
                    <v-row no-gutters>
                      <v-col cols="12" lg="4" md="4" sm="4" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          <strong> {{ $t("UserData.AR_NAME") }}: </strong>
                        </v-card>
                      </v-col>
                      <v-col cols="12" lg="8" md="8" sm="8" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          {{ arName || $t("NO_DATA") }}
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" lg="6" md="12" sm="12" xl="6">
                    <v-row no-gutters>
                      <v-col cols="12" lg="4" md="4" sm="4" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          <strong> {{ $t("UserData.EN_NAME") }}: </strong>
                        </v-card>
                      </v-col>
                      <v-col cols="12" lg="8" md="8" sm="8" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          {{ enName || $t("NO_DATA") }}
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12" lg="6" md="12" sm="12">
                    <v-row no-gutters>
                      <v-col cols="12" lg="4" md="4" sm="4" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          <strong> {{ $t("UserData.NATIONALITY") }}: </strong>
                        </v-card>
                      </v-col>
                      <v-col cols="12" lg="8" md="8" sm="8" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          {{
                            serverTranslate(nationalityCountry) || $t("NO_DATA")
                          }}
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" lg="6" md="12" sm="12" xl="6">
                    <v-row no-gutters>
                      <v-col cols="12" lg="4" md="4" sm="4" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          <strong>
                            {{
                              cardType === 1
                                  ? $t("UserData.NATIONAL_ID")
                                  : $t("UserData.PASSPORT")
                            }}:
                          </strong>
                        </v-card>
                      </v-col>
                      <v-col cols="12" lg="8" md="8" sm="8" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          {{ cardID || $t("NO_DATA") }}
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="6" lg="4" md="6" sm="6">
                    <v-row no-gutters>
                      <v-col cols="12" lg="4" md="4" sm="4" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          <strong> {{ $t("UserData.GENDER") }}: </strong>
                        </v-card>
                      </v-col>
                      <v-col cols="12" lg="8" md="8" sm="8" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          {{
                            gender === 13
                                ? $t("UserData.MALE")
                                : $t("UserData.FEMALE")
                          }}
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="6" lg="4" md="6" sm="6">
                    <v-row no-gutters>
                      <v-col cols="12" lg="4" md="4" sm="4" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          <strong> {{ $t("ADMISSION_DATA.STEP1.RELIGION") }}: </strong>
                        </v-card>
                      </v-col>
                      <v-col cols="12" lg="8" md="8" sm="8" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          {{
                            religion === 84
                                ? $t("ADMISSION_DATA.STEP1.MUSLIM")
                                : $t("ADMISSION_DATA.STEP1.CHRISTIAN")
                          }}
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>


                  <v-col cols="6" lg="4" md="6" sm="6" xl="4">
                    <v-row no-gutters>
                      <v-col cols="12" lg="4" md="4" sm="4" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          <strong> {{ $t("UserData.BIRTHDAY") }}: </strong>
                        </v-card>
                      </v-col>
                      <v-col cols="12" lg="8" md="8" sm="8" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          {{ dOB || $t("NO_DATA") }}
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>

                  <!--  BIRTH PLACE     -->
                  <v-col cols="12">
                    <v-card class="pa-1 elevation-0 body-1">
                      <strong> {{ $t("UserData.BIRTHPLACE") }}: </strong>
                    </v-card>
                  </v-col>
                  <v-col class="px-4" cols="12" lg="4" md="12" sm="12">
                    <v-row no-gutters>
                      <v-col cols="12" lg="5" sm="4" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          <strong> {{ $t("UserData.COUNTRY") }}: </strong>
                        </v-card>
                      </v-col>
                      <v-col cols="12" lg="7" sm="8" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          {{ serverTranslate(birthPlaceCountry) || $t("NO_DATA") }}
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col class="px-4" cols="12" lg="4" md="12" sm="12">
                    <v-row no-gutters>
                      <v-col cols="12" lg="5" sm="4" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          <strong> {{ $t("UserData.STATE") }}: </strong>
                        </v-card>
                      </v-col>
                      <v-col cols="12" lg="7" sm="8" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          {{ (birthPlaceState?serverTranslate(birthPlaceState):$t("NO_DATA"))}}
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col class="px-4" cols="12" lg="4" md="12" sm="12">
                    <v-row no-gutters>
                      <v-col cols="12" lg="5" sm="4" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          <strong> {{ $t("UserData.CITY") }}: </strong>
                        </v-card>
                      </v-col>
                      <v-col cols="12" lg="7" sm="8" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          {{(birthPlaceCity?serverTranslate(birthPlaceCity):$t("NO_DATA")) }}
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>


                  <v-col cols="12" lg="6" md="12" sm="12" xl="6">
                    <v-row no-gutters>
                      <v-col cols="12" lg="4" md="4" sm="4" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          <a @click="open = true; componentKey += 1;"> {{ $t("UserData.CHANGE_PASSWORD") }}</a>
                          <v-icon
                              class="mt-n2 mx-2 pointer"
                              color="primary"
                              @click="open = true; componentKey += 1;">mdi-account-key
                          </v-icon>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header
                  class="white--text expansion-header"
                  color="primary"
              >
                {{ $t("UserData.CONTACT") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="mt-2" no-gutters>
                  <v-col cols="12" lg="6" md="12" sm="12">
                    <v-row no-gutters>
                      <v-col cols="12" lg="4" md="4" sm="4" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          <strong> {{ $t("UserData.PHONE") }}: </strong>
                        </v-card>
                      </v-col>
                      <v-col cols="12" lg="8" md="8" sm="8" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          {{ telephone || $t("NO_DATA") }}
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" lg="6" md="12" sm="12" xl="6">
                    <v-row no-gutters>
                      <v-col cols="12" lg="4" md="4" sm="4" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          <strong> {{ $t("UserData.MOBILE") }}: </strong>
                        </v-card>
                      </v-col>
                      <v-col cols="12" lg="8" md="8" sm="8" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          <bdi>{{ mobile || $t("NO_DATA") }}</bdi>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <!--  ADDRESS    -->
                  <v-col cols="12">
                    <v-card class="pa-1 elevation-0 body-1">
                      <strong> {{ $t("UserData.ADDRESS") }}: </strong>
                    </v-card>
                  </v-col>
                  <v-col class="px-4" cols="12" lg="4" md="12" sm="12">
                    <v-row no-gutters>
                      <v-col cols="12" lg="5" sm="4" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          <strong> {{ $t("UserData.COUNTRY") }}: </strong>
                        </v-card>
                      </v-col>
                      <v-col cols="12" lg="7" sm="8" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          {{ serverTranslate(addressCountry) || $t("NO_DATA") }}
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col class="px-4" cols="12" lg="4" md="12" sm="12">
                    <v-row no-gutters>
                      <v-col cols="12" lg="5" sm="4" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          <strong> {{ $t("UserData.STATE") }}: </strong>
                        </v-card>
                      </v-col>
                      <v-col cols="12" lg="7" sm="8" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          {{ serverTranslate(addressState) || $t("NO_DATA") }}
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col class="px-4" cols="12" lg="4" md="12" sm="12">
                    <v-row no-gutters>
                      <v-col cols="12" lg="5" sm="4" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          <strong> {{ $t("UserData.CITY") }}: </strong>
                        </v-card>
                      </v-col>
                      <v-col cols="12" lg="7" sm="8" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          {{ serverTranslate(addressCity) || $t("NO_DATA") }}
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                  <!--  EMAIL    -->

                  <v-col cols="12" lg="6" md="12" sm="12">
                    <v-row no-gutters>
                      <v-col cols="12" lg="4" md="4" sm="4" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          <strong> {{ $t("UserData.EMAIL") }}: </strong>
                        </v-card>
                      </v-col>
                      <v-col cols="12" lg="8" md="8" sm="8" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          {{ email || $t("NO_DATA") }}
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header
                  class="white--text expansion-header"
                  color="primary"
              >
                {{ $t("UserData.CERTIFICATE") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="mt-2" no-gutters>
                  <v-col cols="12" lg="6" md="12" sm="12">
                    <v-row no-gutters>
                      <v-col cols="12" lg="4" md="4" sm="4" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          <strong>
                            {{ $t("UserData.CERTIFICATE_TYPE") }}:
                          </strong>
                        </v-card>
                      </v-col>
                      <v-col cols="12" lg="8" md="8" sm="8" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          {{
                            serverTranslate(certificateType) || $t("NO_DATA")
                          }}
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" lg="6" md="12" sm="12">
                    <v-row no-gutters>
                      <v-col cols="12" lg="4" md="4" sm="4" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          <strong>
                            {{ $t("UserData.CERTIFICATE_DEPT") }}:
                          </strong>
                        </v-card>
                      </v-col>
                      <v-col cols="12" lg="8" md="8" sm="8" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          {{ serverTranslate(divisionType) || $t("NO_DATA") }}
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                      v-if="!!equationCertificateType"
                      cols="12"
                      lg="6"
                      md="12"
                      sm="12"
                  >
                    <v-row no-gutters>
                      <v-col cols="12" lg="4" md="4" sm="4" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          <strong>
                            {{ $t("UserData.CERTIFICATE_EQ_TYPE") }}:
                          </strong>
                        </v-card>
                      </v-col>
                      <v-col cols="12" lg="8" md="8" sm="8" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          {{
                            serverTranslate(equationCertificateType) ||
                            $t("NO_DATA")
                          }}
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                      v-if="!!foreignCertificate && !isAnotherForeignCertificate"
                      cols="12"
                      lg="6"
                      md="12"
                      sm="12"
                  >
                    <v-row no-gutters>
                      <v-col cols="12" lg="4" md="4" sm="4" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          <strong>
                            {{ $t("UserData.CERTIFICATE_FOREIGN_TYPE") }}:
                          </strong>
                        </v-card>
                      </v-col>
                      <v-col cols="12" lg="8" md="8" sm="8" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          {{
                            serverTranslate(foreignCertificate) || $t("NO_DATA")
                          }}
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col
                      v-if="!!egyptianCertificate"
                      cols="12"
                      lg="6"
                      md="12"
                      sm="12"
                  >
                    <v-row no-gutters>
                      <v-col cols="12" lg="4" md="4" sm="4">
                        <v-card class="pa-1 elevation-0 body-1">
                          <strong>
                            {{ $t("UserData.CERTIFICATE_EGYPTIAN_TYPE") }}:
                          </strong>
                        </v-card>
                      </v-col>

                      <v-col cols="12" lg="8" md="8" sm="8">
                        <v-card class="pa-1 elevation-0 body-1">
                          {{
                            serverTranslate(egyptianCertificate) || $t("NO_DATA")
                          }}
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col
                      v-if="!!otherCertificateText"
                      cols="12"
                      lg="6"
                      md="12"
                      sm="12"
                  >
                    <v-row no-gutters>
                      <v-col cols="12" lg="4" md="4" sm="4" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          <strong>
                            {{ $t("UserData.CERTIFICATE_OTHER") }}:
                          </strong>
                        </v-card>
                      </v-col>
                      <v-col cols="12" lg="8" md="8" sm="8" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          {{ otherCertificateText || $t("NO_DATA") }}
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" lg="6" md="12" sm="12">
                    <v-row no-gutters>
                      <v-col cols="12" lg="4" md="4" sm="4" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          <strong>
                            {{ $t("UserData.CERTIFICATE_YEAR") }}:
                          </strong>
                        </v-card>
                      </v-col>
                      <v-col cols="12" lg="8" md="8" sm="8" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          {{ preQualYear || $t("NO_DATA") }}
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" lg="6" md="12" sm="12">
                    <v-row no-gutters>
                      <v-col cols="12" lg="4" md="4" sm="4" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          <strong>
                            {{ $t("UserData.CERTIFICATE_RESULT") }}:
                          </strong>
                        </v-card>
                      </v-col>
                      <v-col cols="12" lg="8" md="8" sm="8" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          {{ total || $t("NO_DATA") }}
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" lg="6" md="12" sm="12">
                    <v-row no-gutters>
                      <v-col cols="12" lg="4" md="4" sm="4" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          <strong> {{ $t("UserData.COUNTRY") }}: </strong>
                        </v-card>
                      </v-col>
                      <v-col cols="12" lg="8" md="8" sm="8" xs="12">
                        <v-card class="pa-1 elevation-0 body-1">
                          {{ serverTranslate(preQualCountry) || $t("NO_DATA") }}
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
        <v-col cols="12" order="3">
          <v-btn
              class="float-left"
              color="primary"
              @click="$router.push({ name: 'EditProfile' })"
          >
            {{ $t("EDIT") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <ad-change-password
        v-if="open"
        :key="componentKey"
    />
  </v-card>
</template>

<script>
import serverTranslationsMixin from "@/mixins/serverTranslations.js";
import ChangePassword from "./ChangePassword";

export default {
  name: "View",
  mixins: [serverTranslationsMixin],
  components: {
    "ad-change-password": ChangePassword,
  },
  computed: {
    cols() {
      const {xl, lg, md, sm, xs} = this.$vuetify.breakpoint;
      return xl
          ? [3, 9]
          : lg
              ? [3, 9]
              : md
                  ? [3, 9]
                  : sm
                      ? [6, 6]
                      : xs
                          ? [12, 12]
                          : [12, 12];
    }
  },
  created() {
    this.getUserProfileData();
  },
  data() {
    return {
      panel: [0, 1, 2],
      isAnotherForeignCertificate: false,
      open: false,
      componentKey: 0,
      arName: "",
      enName: "",
      email: "",
      cardID: "",
      cardType: "",
      profilePicture: "",
      nationalityCountry: "",
      addressCountry: "",
      addressState: "",
      addressCity: "",
      birthPlaceCountry: "",
      birthPlaceState: "",
      birthPlaceCity: "",
      gender: 13,
      religion: 84,
      mobile: "",
      telephone: "",
      dOB: "",
      certificateType: "",
      divisionType: "",
      preQualCountry: "",
      equationCertificateType: "",
      foreignCertificate: "",
      egyptianCertificate: "",
      otherCertificateText: "",
      total: "",
      preQualYear: "",

      currentSemName: "",
      currentSemId: "",
      currentYearName: "",
      currentYearId: "",
      countriesList: [],
      addressStatesList: [],
      addressCitiesList: [],
      birthStatesList: [],
      birthCitiesList: [],
      certificateTypes: [],
      divisionTypes: [],
      equationCertificateTypes: [],
      foreignCertificates: [],
      egyptianCertificates: [],
      years: []
    };
  },
  methods: {
    getUserProfileData() {
      this.$http.post("/api/students_data/get_profile_data/", {'userProfile': 'true'}).then(response => {
        const responseData = response.data.data;
        this.$store.commit("profileImage", responseData.profilePicture);
        Object.keys(responseData).forEach(key => {
          this.$data[key] = responseData[key] || "";
        });

        const nationalityCountry = this.countriesList.find(country => {
          return country.id === this.nationalityCountry;
        });
        this.nationalityCountry = nationalityCountry
            ? nationalityCountry.name
            : "";
        const addressCountry = this.countriesList.find(country => {
          return country.id === this.addressCountry;
        });
        this.addressCountry = addressCountry ? addressCountry.name : "";

        if (this.addressState) {
          const addressState = this.addressStatesList.find(state => {
            return state.id === this.addressState;
          });
          this.addressState = addressState ? addressState.name : "";
        }

        if (this.addressCity) {
          const addressCity = this.addressCitiesList.find(city => {
            return city.id === this.addressCity;
          });
          this.addressCity = addressCity ? addressCity.name : "";
        }
        const birthCountry = this.countriesList.find(country => {
          return country.id === this.birthPlaceCountry;
        });
        this.birthPlaceCountry = birthCountry ? birthCountry.name : "";

        if (this.birthPlaceCity) {
          const birthCity = this.birthCitiesList.find(city => {
            return city.id === this.birthPlaceCity;
          });
          this.birthPlaceCity = birthCity ? birthCity.name : "";
        }

        if (this.birthPlaceState) {
          const birthState = this.birthStatesList.find(state => {
            return state.id === this.birthPlaceState;
          });
          this.birthPlaceState = birthState ? birthState.name : "";
        }


        const certificateType = this.certificateTypes.find(certificate => {
          return certificate.id === this.certificateType;
        });
        this.certificateType = certificateType ? certificateType.name : "";

        const divisionType = this.divisionTypes.find(division => {
          return division.id === this.divisionType;
        });
        this.divisionType = divisionType ? divisionType.name : "";

        const preQualYear = this.years.find(year => {
          return year.id === this.preQualYear;
        });
        this.preQualYear = preQualYear ? preQualYear.name : "";

        const equationCertificateType = this.equationCertificateTypes.find(
            certificate => {
              return certificate.id === this.equationCertificateType;
            }
        );
        this.equationCertificateType = equationCertificateType
            ? equationCertificateType.name
            : "";

        const foreignCertificate = this.foreignCertificates.find(
            certificate => {
              return certificate.id === this.foreignCertificate;
            }
        );
        const egyptianCertificate = this.egyptianCertificates.find(
            certificate => {
              return certificate.id === this.egyptianCertificate;
            }
        );
        this.isAnotherForeignCertificate = this.foreignCertificate === 32;
        this.foreignCertificate = foreignCertificate
            ? foreignCertificate.name
            : "";
        this.egyptianCertificate = egyptianCertificate
            ? egyptianCertificate.name
            : "";

        const preQualCountry = this.countriesList.find(country => {
          return country.id === this.preQualCountry;
        });
        this.preQualCountry = preQualCountry ? preQualCountry.name : "";
      });
    },
    changePassword() {
      alert('yes')
    }
  }
};
</script>
